import React, { ReactElement } from 'react'
import { Stack, Text } from '@mindfulchefuk/design-system'
import { RecipeStep } from '@mindfulchefuk/features/Recipes/interfaces'
import sortBy from '@mindfulchefuk/utils/sortBy'

export const RecipeNumberedSteps = ({
  steps,
}: {
  steps: RecipeStep[]
}): ReactElement => (
  <Stack
    as="ol"
    listStyleType="decimal"
    spacing={6}
    ml={20}
    data-testid="recipe-page-numbered-instructions"
  >
    {steps
      .sort((a, b) => sortBy(a.position, b.position))
      .map(({ description, position }) => (
        <Text
          key={`${description}${position}`}
          variant="body-md"
          as="li"
          pl={4}
          data-testid="recipe-step"
        >
          {description}
        </Text>
      ))}
  </Stack>
)
